import React from 'react';
import PropTypes, { any } from 'prop-types';

import Filter, { FilterModal, FilterSection } from './Filter';
import NumericInput from './FilterComponents/CoreComponents/NumericInput';

import { sportTypeIds } from '../../../utils/eventConstants';
import { range } from '../../../utils/validation';

import styles from '../search.scss';

const UtrInputFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, handleFilterUpdate, mobileOnly, desktopOnly, sportTypeId = sportTypeIds.TENNIS, 'data-testid': dataTestId } = props;

    const isTennis = sportTypeId === sportTypeIds.TENNIS;
    const title = isTennis ? 'Enter a UTR Rating (1.0 - 16.0)' : 'Enter a UTR-P Rating (1.0 - 10.0)';

    const error = filterInputs?.rating && range(1, isTennis ? 16 : 10)(filterInputs?.rating);

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'rating'}
                handleFilterClick={handleFilterClick}
                isActive={filters?.rating || filterModal === 'rating'}
                onClick={() => {
                    handleFilterClick('rating');
                }}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                Rating {filters?.rating ? `: ${filters?.rating}` : ''}
            </Filter>
            {filterModal === 'rating' && (
                <FilterModal
                    title={'Rating'}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                    handleFilterSubmit={() => {
                        if (!error) {
                            handleFilterSubmit();
                        }
                    }}
                >
                    <FilterSection data-testid={dataTestId && `${dataTestId}.body`}>
                        {title}
                        <NumericInput
                            value={filterInputs.rating || ''}
                            onChange={(rating) => {
                                handleFilterUpdate({ rating });
                            }}
                            min={1}
                            max={isTennis ? 16 : 10}
                            isHalfStep
                            data-testid={dataTestId && `${dataTestId}.rating-input`}
                        />
                        {!!error && <div className="small text-error" data-testid={dataTestId && `${dataTestId}.error-message`}>{error}</div>}
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

UtrInputFilter.propTypes = {
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    sportTypeId: PropTypes.number,
    'data-testid': PropTypes.string,
};
UtrInputFilter.defaultProps = {
    handleFilterClick: () => { },
    handleFilterSubmit: () => { },
    closeModals: () => { },
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    sportTypeId: sportTypeIds.TENNIS,
    'data-testid': undefined,
};

export default UtrInputFilter;
